import { useMemo } from 'react';
import { useImportExportApi } from '../../../clients/quipli-service/import-export/import-export-api';
import { ImportExportAdapter } from '../../../components/import-export/types';
import { DateTime } from 'luxon';
import { toast } from '../../../util/toasts';
import { Typography } from '../../../components/typography/typography';

type ProductsImportParams = Record<string, never>;
type ProductsExportParams = Record<string, never>;

export const useProductsImportExportAdapter = (
  fetchCallback: () => void,
): ImportExportAdapter<ProductsImportParams, ProductsExportParams> => {
  const api = useImportExportApi();

  return useMemo(
    () => ({
      typeLabel: 'products',
      fileAccept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',

      defaultExportFileName: () => `Products_${DateTime.local().toFormat('D').replaceAll('/', '-')}`,

      export: () => api.exportProducts(),
      import: (file: File) => api.importProducts(file),

      onImportSuccess: () => {
        toast('File uploaded successfully. You will received an email when the import is complete.', 'success');
        fetchCallback();
      },
      onImportError: () => {
        toast('Error importing products', 'error');
        fetchCallback();
      },
      onExportSuccess: () => {
        fetchCallback();
      },
      onExportError: () => {
        toast('Error exporting products', 'error');
        fetchCallback();
      },

      renderSampleFile: () => (
        <div className="text-left px-4 mb-4">
          <Typography type="text-sm" className="text-grey-500">
            <div>Upload an Excel file (XLS or XLSX) in the exported format to update your product list.</div>
          </Typography>
        </div>
      ),
    }),
    [fetchCallback],
  );
};
